import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const AfterGetStartedAPI = async () => {
    try {
        const response = await axiosInstance.get(`/api/after_get_started`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'AfterGetStartedAPI');
    }
};
